import React, { useState } from 'react';
import './PropertyCard.css';
import BrochureViewer from '../BrochureViewer/BrochureViewer';
import CertificateModal from '../CertificateModal/CertificateModal';

export default function PropertyCard({ property }) {
  const [liked, setLiked] = useState(property.liked || false);
  const [showPdf, setShowPdf] = useState(false);
  const [certType, setCertType] = useState(null);

  const hasBrochure = !!property.brochure;
  const projectName = property.address?.split(',')[0] || 'Project';
  const downloadName = property.brochureName || `${projectName.replace(/\s+/g,'_')}_Brochure.pdf`;

  /* Fetch → Blob download so browser always saves (not just opens) */
  const handleDownload = async (e) => {
    e.stopPropagation();
    if (!hasBrochure) return;
    try {
      const res = await fetch(property.brochure);
      if (!res.ok) throw new Error('not ok');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = downloadName;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch {
      const a = document.createElement('a');
      a.href = property.brochure; a.download = downloadName;
      a.click();
    }
  };

  return (
    <>
      <div className="property-card">
        <div className="card-img">
          <img src={property.image} alt={property.address} />
          <button
            className={`wishlist ${liked ? 'active' : ''}`}
            onClick={(e) => { e.stopPropagation(); setLiked(!liked); }}
            aria-label="Toggle wishlist"
          >
            <i className={liked ? 'fa-solid fa-heart' : 'fa-regular fa-heart'} />
          </button>
          {property.hot && (
            <span className="badge hot"><i className="fa fa-fire" /> Hot price</span>
          )}
          {hasBrochure && (
            <span
              className="badge brochure-badge"
              onClick={(e) => { e.stopPropagation(); setShowPdf(true); }}
            >
              <i className="fa fa-file-pdf" /> Official Brochure
            </span>
          )}
        </div>

        <div className="card-body">
          <div className="price">{property.price}</div>
          <div className="address">{property.address}</div>
          <div className="meta">
            {property.beds > 0 && <span><i className="fa fa-bed" /> {property.beds} bedrooms</span>}
            {property.rooms > 0 && <span><i className="fa fa-door-open" /> {property.rooms} rooms</span>}
            <span><i className="fa fa-ruler-combined" /> {property.sqft} Sq. ft</span>
          </div>

          <div className="card-actions">
            {hasBrochure && (
              <>
                <button
                  className="card-action-btn view-pdf-btn"
                  onClick={(e) => { e.stopPropagation(); setShowPdf(true); }}
                >
                  <i className="fa fa-eye" /> View PDF
                </button>
                <button
                  className="card-action-btn download-btn"
                  onClick={handleDownload}
                >
                  <i className="fa fa-download" /> Download
                </button>
              </>
            )}
            <button
              className="card-action-btn booking-btn"
              onClick={(e) => { e.stopPropagation(); setCertType('booking'); }}
            >
              <i className="fa fa-certificate" /> Booking
            </button>
            <button
              className="card-action-btn appt-btn"
              onClick={(e) => { e.stopPropagation(); setCertType('appointment'); }}
            >
              <i className="fa fa-calendar-check" /> Appt.
            </button>
          </div>
        </div>
      </div>

      {showPdf && hasBrochure && (
        <BrochureViewer
          pdfUrl={property.brochure}
          title={projectName}
          onClose={() => setShowPdf(false)}
        />
      )}
      {certType && (
        <CertificateModal
          type={certType}
          project={projectName}
          onClose={() => setCertType(null)}
        />
      )}
    </>
  );
}
